<template>
  <el-drawer
    :withHeader="false"
    :visible.sync="drawer"
    direction="ttb"
    size="100%"
  >
    <el-button
      icon="el-icon-error"
      style="
        font-size: 24px;
        color: rgb(245, 108, 108);
        position: absolute;
        right: 0;
        z-index: 1;
      "
      circle
      @click="drawer = false"
    ></el-button>

    <el-row style="height: 220px; background-color: #4390ff">
      <i class="el-icon-question"></i><span>Hi,请问有什么可以帮您?</span>
      <!-- 这里是侧边栏-->
      <el-col
        :span="5"
        style="position: relative; margin-left: 4%; margin-top: 60px"
      >
        <el-card
          class="box-card"
          style="margin-top: 60px; height: 85vh; overflow: auto"
        >
          <div class="zTreeDiv">
            <zTree
              :zNodes="zNodes"
              @getData="getData"
              :check="false"
              :options="{
                id: 'hpdc01',
                label: 'hpdc03',
                pid: 'hpdc02',
                zTreeId: 'hpdc2',
                delType: {
                  add: false,
                  update: false,
                  del: false,
                },
              }"
              ref="zTree"
            />
          </div>
        </el-card>
      </el-col>
      <!-- 这里是内容显示区域 -->
      <el-col
        :span="17"
        style="position: relative; margin-left: 2%; margin-top: 30px"
      >
        <el-card class="card-conter" style="margin-top: 60px; height: 85vh">
          <p v-html="helpDocDetial.hpdc06"></p>
        </el-card>
      </el-col>
    </el-row>
  </el-drawer>
</template>

<script>
import { adminRoute, enterpriseRoute, projectRoute } from "@/router";
import zTree from "@/components/zTree"; //导入封装树形控件
import { GetControlData, Findhelpdoc } from "@/setAxios";
export default {
  components: { zTree },
  data() {
    return {
      drawer: false,
      zNodes: null,
      helpDocDetial: {
        hpdc06: "",
      },
    };
  },
  methods: {
    async GetControlData(type) {
      let params = {
        type,
      };
      let res = await GetControlData({ params });
      this.zNodes = res.Data;
    },
    //详细信息
    async getData(helpocid) {
      if (helpocid == "") return;
      let params = {
        helpocid,
      };
      let res = await Findhelpdoc({ params });
      this.helpDocDetial = res.Data;
    },
    //判断当前路由权限
    open() {
      this.drawer = true;
      if (adminRoute.indexOf(this.$route.name.toLowerCase()) >= 0) {
        this.GetControlData(1);
      } else if (enterpriseRoute.indexOf(this.$route.name.toLowerCase()) >= 0) {
        this.GetControlData(2);
      } else if (projectRoute.indexOf(this.$route.name.toLowerCase()) >= 0) {
        this.GetControlData(3);
      }
      // else if (this.$route.name == "enterpriseIndex") {
      //   this.$message.warning("请先进入");
      //   this.drawer = false;
      // }
      else {
        this.GetControlData(4);
      }
    },
  },
};
</script>

<style>
/* @import url("/assets/css/page-health-riskQuestion.css"); */
</style>

<style lang="less" scoped>
/deep/.el-card .el-card__body {
  height: 95% !important;
  overflow: auto !important;
}
span {
  font-size: 30px;
  position: relative;
}
.el-icon-question:before {
  content: "\E7A4";
  font-size: 30px;
  color: #ffffff;
  position: relative;
  margin-left: 30vh;
  top: 40px;
}
.el-row {
  span {
    font-size: 24px;
    color: white;
    top: 40px;
  }
  a {
    font-size: 20px;
  }
}
.zTreeDiv {
  overflow: auto;
  width: 99%;
  position: relative;
  padding-top: 10px;
}
.body-cont {
  position: relative;
  width: 85%;
  padding-left: 15px;
}
.content-hover {
  height: 75vh;
}
</style>